import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar", "overlay", "logo", "logoIcon", "menuGroupTitle", "menuGroupIcon", "menuItemText"]

  connect() {
    this.sidebarOpen = false
  }

  toggle() {
    this.sidebarOpen = !this.sidebarOpen
    this.updateUI()
  }

  close() {
    this.sidebarOpen = false
    this.updateUI()
  }

  updateUI() {
    if (this.hasSidebarTarget) {
      if (this.sidebarOpen) {
        this.sidebarTarget.classList.remove('-translate-x-full')
        this.sidebarTarget.classList.add('translate-x-0', 'lg:w-[90px]')
      } else {
        this.sidebarTarget.classList.add('-translate-x-full')
        this.sidebarTarget.classList.remove('translate-x-0', 'lg:w-[90px]')
      }
    }

    if (this.hasOverlayTarget) {
      this.overlayTarget.style.display = this.sidebarOpen ? 'block' : 'none'
    }

    // Toggle logo visibility
    this.logoTargets.forEach(logo => {
      if (this.sidebarOpen) {
        logo.classList.add('hidden')
      } else {
        logo.classList.remove('hidden')
      }
    })

    this.logoIconTargets.forEach(icon => {
      if (this.sidebarOpen) {
        icon.classList.remove('hidden')
        icon.classList.add('lg:block')
      } else {
        icon.classList.add('hidden')
        icon.classList.remove('lg:block')
      }
    })

    // Toggle menu text visibility
    this.menuGroupTitleTargets.forEach(title => {
      if (this.sidebarOpen) {
        title.classList.add('lg:hidden')
      } else {
        title.classList.remove('lg:hidden')
      }
    })

    this.menuGroupIconTargets.forEach(icon => {
      if (this.sidebarOpen) {
        icon.classList.remove('hidden')
        icon.classList.add('lg:block')
      } else {
        icon.classList.add('hidden')
      }
    })

    this.menuItemTextTargets.forEach(text => {
      if (this.sidebarOpen) {
        text.classList.add('lg:hidden')
      } else {
        text.classList.remove('lg:hidden')
      }
    })
  }
}
